<template>
  <TransitionsFade>
    <div
      v-if="!employees?.length"
      class="heading-footer"
      v-bind="$attrs"
    >
      {{ $t('No employees found') }}
    </div>

    <TransitionGroup
      v-else
      name="slide-in-list"
      tag="ul"
      v-bind="$attrs"
      class="grid-base md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
    >
      <!-- GROENTENFRUIT HUIS -->
      <h3 class="heading-sub col-span-full">
        {{ $t('Fresh Produce Centre') }}
      </h3>
      <li
        v-for="employee in gfhEmployees"
        :key="employee.id"
      >
        <EmployeesTile :employee="employee" />
      </li>

      <!-- SECRETARIAAT -->
      <h3 class="heading-sub col-span-full mt-6">
        {{ $t('Secretariat') }}
      </h3>
      <li
        v-for="employee in adminEmployees"
        :key="employee.id"
      >
        <EmployeesTile :employee="employee" />
      </li>

      <!-- FOOD COMPASS -->
      <h3 class="heading-sub col-span-full mt-6">
        {{ $t('Food Compass') }}
      </h3>
      <li
        v-for="employee in foodCompassEmployees"
        :key="employee.id"
      >
        <EmployeesTile :employee="employee" />
      </li>
    </TransitionGroup>
  </TransitionsFade>
</template>

<script setup lang="ts">
import type {EmployeesQuery} from '~/graphql/graphql';

const props = defineProps<{
  employees: EmployeesQuery['employees'];
}>();

const gfhEmployees = computed(() => props.employees.filter(employee => employee.company === 'GroentenFruit Huis'));
const adminEmployees = computed(() => props.employees.filter(employee => employee.department === 'Secretariaat'));
const foodCompassEmployees = computed(() => props.employees.filter(employee => employee.company === 'Food Compass'));
</script>
